import { Box, Button } from '@chakra-ui/react'

interface ChangePasswordButtonProps {
  onChangePassword: () => void
}

const ChangePasswordButton = ({
  onChangePassword,
}: ChangePasswordButtonProps) => {
  return (
    <Box>
      <Button variant='link' onClick={onChangePassword}>
        Change Password
      </Button>
    </Box>
  )
}

export default ChangePasswordButton
